<template>
  <TextField
    type="text"
    :placeholder="label"
    :value="value"
    @input="$emit('input', $event)"
    :rules="[...rules, validation.url]"
  />
</template>

<script>
export default {
  props: {
    label: String,
    value: String,
    rules: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style></style>
